// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78b57cc2","885":"dad057da"}[chunkId] + ".chunk.js";
};